import { useMutation } from '@tanstack/react-query'
import { confirmResetPassword } from 'aws-amplify/auth'

import { sendEvent } from 'src/shared/api/events/send-event'

export const useConfirmPasswordReset = () => {
  return useMutation({
    mutationFn: async ({ email, code, newPassword }: { email: string; code: string; newPassword: string }) => {
      const result = await confirmResetPassword({
        username: email,
        confirmationCode: code,
        newPassword,
      })
      sendEvent({ eventType: 'auth_password_reset_confirmed', info: { email } })
      return result
    },
    onError: (error: unknown) => {
      const errorName = error instanceof Error ? error.name : 'unknown'
      sendEvent({
        eventType: 'auth_password_reset_confirm_error',
        info: { error: errorName },
      })
    },
  })
}
